/*
* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/

export class SellerListRequest {


    public limit: number;
    public offset: number;
    public name: string;
    public email: string;
    public status: number;
    public count: number;
    public customerId: number;
    public vendorId: number;


    constructor(sellerListRequest: any) {
        this.limit = sellerListRequest.limit || '';
        this.offset = sellerListRequest.offset || '';
        this.name = sellerListRequest.name || '';
        this.email = sellerListRequest.email || '';
        this.status = sellerListRequest.status;
        this.count = sellerListRequest.count || '';
        this.customerId = sellerListRequest.customerId || '';
        this.vendorId = sellerListRequest.vendorId || '';
    }
}
